// extracted by mini-css-extract-plugin
module.exports = {"carousel":"special-projects_carousel__BxlMt","carousel__content":"special-projects_carousel__content__QVD2_","item":"special-projects_item__4bLez"};